import React, { ReactElement } from "react";

interface IProps {
	active: "products" | "bundles" | "libraries";
}

const NAV_ITEMS = [
	{ key: "products", label: "Products", href: "/products", icon: "fa-cube" },
	{ key: "bundles", label: "Bundles", href: "/products/bundles", icon: "fa-cubes" },
	{ key: "libraries", label: "Libraries", href: "/products/libraries", icon: "fa-book" },
];

export const ProductsNav = ({ active }: IProps): ReactElement => {
	return (
		<nav className="products-subnav">
			{NAV_ITEMS.map(item => (
				<a
					key={item.key}
					href={item.href}
					className={`products-subnav-item ${active === item.key ? "active" : ""}`}
				>
					<i className={`fa ${item.icon}`} />
					{item.label}
				</a>
			))}
		</nav>
	);
};
